import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Gift = ({ className = '', svgSize = ICON_SIZES.MD }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12H26V24.6667C26 25.403 25.403 26 24.6667 26H7.33333C6.59695 26 6 25.403 6 24.6667V12Z"
          fill="none"
          stroke={theme.icon.stroke}
          strokeWidth="1.33333"
          strokeLinejoin="round"
        />
        <path
          d="M13.333 8H18.6663V26H13.333V8Z"
          fill={theme.icon.fill}
          stroke={theme.icon.stroke}
          strokeWidth="1.33333"
          strokeLinejoin="round"
        />
        <path
          d="M10.667 8C9.56242 8 8.66699 7.10457 8.66699 6C8.66699 4.89543 9.56242 4 10.667 4C12.3337 4 13.667 8 15.667 8"
          fill="none"
          stroke={theme.icon.stroke}
          strokeWidth="1.33333"
          strokeLinejoin="round"
        />
        <path
          d="M20.333 8C21.4376 8 22.333 7.10457 22.333 6C22.333 4.89543 21.4376 4 20.333 4C18.6663 4 17.333 8 15.333 8"
          fill="none"
          stroke={theme.icon.stroke}
          strokeWidth="1.33333"
          strokeLinejoin="round"
        />
        <path
          d="M5.33301 12H26.6663V9.33333C26.6663 8.59695 26.0694 8 25.333 8H6.66634C5.92996 8 5.33301 8.59695 5.33301 9.33333V12Z"
          fill="none"
          stroke={theme.icon.stroke}
          strokeWidth="1.33333"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.167 14H33.8337V45.5H22.167V14Z" fill={theme.icon.fill} />
      <path
        d="M35.583 6.125C37.9993 6.125 39.958 8.08376 39.958 10.5C39.958 11.485 39.6323 12.3938 39.083 13.125H44.333C46.1048 13.125 47.5408 14.5612 47.541 16.333V19.833C47.541 20.6468 47.0638 21.3467 46.375 21.6748V43.167C46.3748 44.9385 44.9385 46.3747 43.167 46.375H12.833C11.0614 46.3748 9.62518 44.9386 9.625 43.167V21.6758C8.93567 21.3478 8.45801 20.6471 8.45801 19.833V16.333C8.45818 14.5614 9.89437 13.1252 11.666 13.125H16.916C16.3668 12.3938 16.041 11.4849 16.041 10.5C16.041 8.08387 17.9999 6.12519 20.416 6.125C21.4976 6.125 22.4041 6.76804 23.1279 7.46289C23.8654 8.17093 24.5845 9.10527 25.2588 9.95703C25.9572 10.8392 26.6203 11.6505 27.3057 12.2451C27.5459 12.4535 27.7769 12.6235 27.999 12.7568C28.2215 12.6234 28.4527 12.4538 28.6934 12.2451C29.3788 11.6505 30.0418 10.8392 30.7402 9.95703C31.4145 9.10533 32.1337 8.17091 32.8711 7.46289C33.5949 6.76804 34.5015 6.12501 35.583 6.125ZM34.708 21.875V44.625H43.167C43.972 44.6247 44.6248 43.972 44.625 43.167V21.875H34.708ZM23.041 21.875V44.625H32.958V21.875H23.041ZM11.375 43.167C11.3752 43.9722 12.0279 44.6248 12.833 44.625H21.291V21.875H11.375V43.167ZM11.666 14.875C10.8609 14.8752 10.2082 15.5279 10.208 16.333V19.833C10.208 19.9941 10.3389 20.125 10.5 20.125H21.291V14.875H11.666ZM23.041 14.875V20.125H32.958V14.875H23.041ZM34.708 14.875V20.125H45.5C45.6609 20.1248 45.791 19.994 45.791 19.833V16.333C45.7908 15.5277 45.1383 14.875 44.333 14.875H34.708ZM20.416 7.875C18.9664 7.87519 17.791 9.05037 17.791 10.5C17.791 11.8593 18.8245 12.9771 20.1484 13.1113L20.416 13.125H25.6865C25.0414 12.4863 24.4402 11.7422 23.8867 11.043C23.1757 10.1448 22.5456 9.32904 21.916 8.72461C21.2727 8.10704 20.7928 7.875 20.416 7.875ZM35.583 7.875C35.2063 7.87501 34.7271 8.10729 34.084 8.72461C33.4544 9.32897 32.8242 10.145 32.1133 11.043C31.5597 11.7422 30.9577 12.4863 30.3125 13.125H35.583L35.8516 13.1113C37.1751 12.9768 38.208 11.8591 38.208 10.5C38.208 9.05025 37.0328 7.875 35.583 7.875Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Gift.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Gift;
